<template>
  <IQOS required :systemDependency="mode" :title="$t('preorder.packaging.title')">
    <!-- <CircleToggle :value="packaging_type == 'free'" @input="setType('free')">{{
      $t("preorder.packaging.type_free")
    }}</CircleToggle>
    <CircleToggle
      class="iqos-group-item"
      :value="packaging_type == 'constant'"
      @input="setType('constant')"
      >{{ $t("preorder.packaging.type_non_free") }}</CircleToggle
    >

    <CircleToggle
      class="iqos-group-item"
      :value="packaging_type == 'weighted'"
      @input="setType('weighted')"
      >Smart</CircleToggle
    > -->
    <BaseTabSwitcher 
      class="w-100 mt-16"
      :value="packaging_type"
      @input="setType"
      size="md"
      :tabs="[
        {
          text: $t('preorder.packaging.type_free'),
          value: 'free'
        },
        {
          text: $t('preorder.packaging.type_non_free'),
          value: 'constant'
        },
        {
          text: 'Smart',
          value: 'weighted'
        }
      ]"/>

    <div class="paid-package-options mt-16" v-if="packaging_type != 'free'">
      <div
        class="fixed-package-container"
        v-if="packaging_type == 'constant'"
      >
        <BaseUnitInput
          fullWidth
          class="w-100"
          :unitPlaceholder="currency.symbol"
          type="number"
          v-model.number="package_cost"
          :placeholder="$t('preorder.packaging.price_ph')"
          :valid="!!package_cost"
          @blur="onEditFinish"
          v-if="editing"
        />
        <BaseInput
          class="package-input"
          :value="`${package_cost}${currency.symbol}`"
          :placeholder="$t('preorder.packaging.price_ph')"
          :readonly="true"
          
          v-if="!editing"
        />
        <p class="iqos-comment qrw-paragraph-md mt-16" v-if="editing">
          {{ $t("preorder.packaging.constant_hint") }}
        </p>
      </div>
      <div
        class="variable-package-container"
        v-if="packaging_type == 'weighted'"
      >
        <p class="iqos-comment qrw-paragraph-md mt-16">
          {{ $t("preorder.packaging.smart_comment") }}
        </p>
        <router-link class="iqos-flex-right mt-16" tag="div" to="/menus">
          <BaseButton size="md" variant="secondary" color="v1-grey-10">{{
            $t("preorder.packaging.smart_btn")
          }}</BaseButton>
        </router-link>
      </div>
    </div>

    <!-- <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @accept="onEditFinish"
      @cancel="hideEditUI"
    /> -->
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import CircleToggle from "@/components/CircleToggle.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";
import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    IQOS,
    IQOSActions,
    CircleToggle,
    RoundCheckbox,
    BlackInput,
    BlackSelect,
    DashboardButton,
  },
  props: {
    mode: {
      type: String,
      default: "delivery",
    },
  },
  data() {
    return {
      editing: true,

      package_cost: null,
      packaging_type: "free",
      package_costs: [],
      cost_valid: true
    };
  },
  methods: {
    onEditFinish() {
      if (this.packaging_type == "constant" && !this.package_cost) {
        this.cost_valid = false;
        return;
      }

      this.cost_valid = true;

      this.$store.commit("setCafePackageCosts", {
        packaging_type: this.packaging_type,
        package_cost: this.package_cost,
        package_costs: this.package_costs,
        mode: this.mode,
      });
      this.$store.dispatch("saveCafe");

      // this.editing = false;

      this.$store.dispatch("auditlog/write", {
        type: "packaging",
        payload: {
          mode: this.mode,
          type: this.packaging_type,
        },
      });
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    reset() {
      if (this.cafe[this.mode].package_costs) {
        this.package_costs = this.cafe[this.mode].package_costs.slice();
      }

      if (this.cafe[this.mode].packaging_type) {
        this.packaging_type = this.cafe[this.mode].packaging_type;
      }

      if (this.cafe[this.mode].package_cost) {
        this.package_cost = this.cafe[this.mode].package_cost;
      }
    },
    setType(arg) {
      this.packaging_type = arg;
      this.onEditFinish();
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style scoped>
hr {
  border: 1px solid #908f8d;
}

.package-input {
  width: 100%;
}

.variable-row {
  display: flex;
  align-items: center;
}

.row-input {
  margin-right: 1.7vh;
  text-align-last: center;
}

.delete-button {
  height: 3.5vh;
  width: auto;
  cursor: pointer;
}

.add-package-button {
  /* float: right; */
}

.invalid-input {
  border: 2px solid #e2223b;
}
</style>